"use client";

import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMenuList } from "../__chunks/AN3MJ3OG.js";
import { useMenuProviderContext } from "../__chunks/SJPAIJOW.js";
import "../__chunks/QVEJ36PB.js";
import "../__chunks/CWIRMIEN.js";
import "../__chunks/IKLZZMLE.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import { useHovercard } from "../__chunks/QLQGB5A3.js";
import "../__chunks/X7QOZUD3.js";
import "../__chunks/DUIQBYXB.js";
import { createDialogComponent } from "../__chunks/YLXVVG22.js";
import "../__chunks/RYNM3PZY.js";
import "../__chunks/D7GLA236.js";
import "../__chunks/IGR4SXG2.js";
import "../__chunks/ESSM74HH.js";
import "../__chunks/TBGPDHVR.js";
import "../__chunks/IT6VQU5B.js";
import "../__chunks/7V5QX4SZ.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/2PGBN2Y4.js";
import "../__chunks/63XF7ACK.js";
import "../__chunks/AOUGVQZ3.js";
import "../__chunks/K2ZF5NU7.js";
import "../__chunks/SCDU7JWG.js";
import "../__chunks/EGBLFVR2.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/OJXDGVKQ.js";
import "../__chunks/ND57YZ3V.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/UYRBEP7M.js";
import "../__chunks/5HEBF2AL.js";
import "../__chunks/DPAO6G5R.js";
import "../__chunks/COWZSPJ7.js";
import "../__chunks/CMXOY7UW.js";
import "../__chunks/JDEWEW7S.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/2ATXICAB.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/B5WJDZ55.js";
import "../__chunks/C76P7QQC.js";
import { useStoreState } from "../__chunks/CTKPPFRS.js";
import { useMergeRefs } from "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu.tsx
import { fireEvent } from "@ariakit/core/utils/events";
import { hasFocusWithin } from "@ariakit/core/utils/focus";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { createRef, useEffect, useMemo, useRef, useState } from "react";
var TagName = "div";
var useMenu = createHook(function useMenu2(_a) {
  var _b = _a,
    store = _b.store,
    _b$modal = _b.modal,
    modalProp = _b$modal === void 0 ? false : _b$modal,
    _b$portal = _b.portal,
    portal = _b$portal === void 0 ? !!modalProp : _b$portal,
    _b$hideOnEscape = _b.hideOnEscape,
    _hideOnEscape = _b$hideOnEscape === void 0 ? true : _b$hideOnEscape,
    _b$autoFocusOnShow = _b.autoFocusOnShow,
    autoFocusOnShow = _b$autoFocusOnShow === void 0 ? true : _b$autoFocusOnShow,
    _hideOnHoverOutside = _b.hideOnHoverOutside,
    alwaysVisible = _b.alwaysVisible,
    props = __objRest(_b, ["store", "modal", "portal", "hideOnEscape", "autoFocusOnShow", "hideOnHoverOutside", "alwaysVisible"]);
  var context = useMenuProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component.");
  var ref = useRef(null);
  var parentMenu = store.parent;
  var parentMenubar = store.menubar;
  var hasParentMenu = !!parentMenu;
  var parentIsMenubar = !!parentMenubar && !hasParentMenu;
  props = __spreadProps(__spreadValues({}, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  var _a2 = useMenuList(__spreadValues({
      store: store,
      alwaysVisible: alwaysVisible
    }, props)),
    ariaLabelledBy = _a2["aria-labelledby"],
    menuListProps = __objRest(_a2, ["aria-labelledby"]);
  props = menuListProps;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    initialFocusRef = _useState2[0],
    setInitialFocusRef = _useState2[1];
  var autoFocusOnShowState = store.useState("autoFocusOnShow");
  var initialFocus = store.useState("initialFocus");
  var baseElement = store.useState("baseElement");
  var items = store.useState("renderedItems");
  useEffect(function () {
    var cleaning = false;
    setInitialFocusRef(function (prevInitialFocusRef) {
      var _a3, _b2, _c;
      if (cleaning) return;
      if (!autoFocusOnShowState) return;
      if ((_a3 = prevInitialFocusRef == null ? void 0 : prevInitialFocusRef.current) == null ? void 0 : _a3.isConnected) return prevInitialFocusRef;
      var ref2 = createRef();
      switch (initialFocus) {
        case "first":
          ref2.current = ((_b2 = items.find(function (item) {
            return !item.disabled && item.element;
          })) == null ? void 0 : _b2.element) || null;
          break;
        case "last":
          ref2.current = ((_c = _toConsumableArray(items).reverse().find(function (item) {
            return !item.disabled && item.element;
          })) == null ? void 0 : _c.element) || null;
          break;
        default:
          ref2.current = baseElement;
      }
      return ref2;
    });
    return function () {
      cleaning = true;
    };
  }, [store, autoFocusOnShowState, initialFocus, items, baseElement]);
  var modal = hasParentMenu ? false : modalProp;
  var mayAutoFocusOnShow = !!autoFocusOnShow;
  var canAutoFocusOnShow = !!initialFocusRef || !!props.initialFocus || !!modal;
  var contentElement = useStoreState(store.combobox || store, "contentElement");
  var parentContentElement = useStoreState((parentMenu == null ? void 0 : parentMenu.combobox) || parentMenu, "contentElement");
  var preserveTabOrderAnchor = useMemo(function () {
    if (!parentContentElement) return;
    if (!contentElement) return;
    var role = contentElement.getAttribute("role");
    var parentRole = parentContentElement.getAttribute("role");
    var parentIsMenuOrMenubar = parentRole === "menu" || parentRole === "menubar";
    if (parentIsMenuOrMenubar && role === "menu") return;
    return parentContentElement;
  }, [contentElement, parentContentElement]);
  if (preserveTabOrderAnchor !== void 0) {
    props = __spreadValues({
      preserveTabOrderAnchor: preserveTabOrderAnchor
    }, props);
  }
  props = useHovercard(__spreadProps(__spreadValues({
    store: store,
    alwaysVisible: alwaysVisible,
    initialFocus: initialFocusRef,
    autoFocusOnShow: mayAutoFocusOnShow ? canAutoFocusOnShow && autoFocusOnShow : autoFocusOnShowState || !!modal
  }, props), {
    hideOnEscape: function hideOnEscape(event) {
      if (isFalsyBooleanCallback(_hideOnEscape, event)) return false;
      store == null ? void 0 : store.hideAll();
      return true;
    },
    hideOnHoverOutside: function hideOnHoverOutside(event) {
      var disclosureElement = store == null ? void 0 : store.getState().disclosureElement;
      var getHideOnHoverOutside = function getHideOnHoverOutside() {
        if (typeof _hideOnHoverOutside === "function") {
          return _hideOnHoverOutside(event);
        }
        if (_hideOnHoverOutside != null) return _hideOnHoverOutside;
        if (hasParentMenu) return true;
        if (!parentIsMenubar) return false;
        if (!disclosureElement) return true;
        if (hasFocusWithin(disclosureElement)) return false;
        return true;
      };
      if (!getHideOnHoverOutside()) return false;
      if (event.defaultPrevented) return true;
      if (!hasParentMenu) return true;
      if (!disclosureElement) return true;
      fireEvent(disclosureElement, "mouseout", event);
      if (!hasFocusWithin(disclosureElement)) return true;
      requestAnimationFrame(function () {
        if (hasFocusWithin(disclosureElement)) return;
        store == null ? void 0 : store.hide();
      });
      return false;
    },
    modal: modal,
    portal: portal,
    backdrop: hasParentMenu ? false : props.backdrop
  }));
  props = __spreadValues({
    "aria-labelledby": ariaLabelledBy
  }, props);
  return props;
});
var Menu = createDialogComponent(forwardRef(function Menu2(props) {
  var htmlProps = useMenu(props);
  return createElement(TagName, htmlProps);
}), useMenuProviderContext);
export { Menu, useMenu };